export default __webpack_public_path__ + "static/media/IconBlock.37d36760.svg";